import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import { AddTask as AddTaskIcon } from '@mui/icons-material';
import type { AssignTicketDialogProps } from './types';

const AssignTicketDialog: React.FC<AssignTicketDialogProps> = ({
  open,
  onClose,
  workflow,
  availableTickets,
  selectedTicketId,
  onTicketSelect,
  onAssign,
  isAssigning,
}) => {
  if (!workflow) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <AddTaskIcon color="secondary" />
          Ticket zu Workflow zuordnen
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Alert severity="info" sx={{ mb: 2 }}>
            Workflow: <strong>{workflow.name}</strong>
          </Alert>

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Ticket auswählen</InputLabel>
            <Select
              value={selectedTicketId || ''}
              onChange={(e) => onTicketSelect(e.target.value as number)}
              label="Ticket auswählen"
            >
              {availableTickets.map((ticket) => (
                <MenuItem key={ticket.ticketID} value={ticket.ticketID}>
                  #{ticket.ticketID} - {ticket.titel}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {availableTickets.length === 0 && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              Keine verfügbaren Tickets ohne Workflow-Zuordnung gefunden.
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          variant="contained"
          onClick={onAssign}
          disabled={isAssigning || !selectedTicketId}
          startIcon={isAssigning ? <CircularProgress size={16} /> : <AddTaskIcon />}
        >
          {isAssigning ? 'Zuordnen...' : 'Zuordnen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignTicketDialog;
